import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terminos-condiciones-modal',
  templateUrl: './terminos-condiciones-modal.component.html',
  styleUrls: ['./terminos-condiciones-modal.component.scss']
})
export class TerminosCondicionesModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
